import React from 'react';
import { ProductItem, categoryColors } from '../productCatalogTypes';
import { RowActionsMenu } from '../../../../components/RowActionsMenu';
import styles from './ProductCatalogTable.module.css';

interface ProductCatalogTableProps {
  items: ProductItem[];
  onEdit?: (id: number) => void;
  onDelete?: (id: number) => void;
}

export const ProductCatalogTable: React.FC<ProductCatalogTableProps> = ({ items, onEdit, onDelete }) => {
  const showActions = !!(onEdit || onDelete);
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>SKU</th>
            <th>Product Name</th>
            <th>Category</th>
            <th className={styles.right}>Cost</th>
            <th className={styles.right}>Tier A</th>
            <th className={styles.right}>Tier B</th>
            <th className={styles.right}>Tier C</th>
            <th className={styles.right}>Tier D</th>
            <th className={styles.right}>Stock</th>
            <th className={styles.right}>Margin</th>
            {showActions && <th></th>}
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.sku}>
              <td className={styles.skuCell}>
                <div>{item.sku}</div>
                {item.barcode && (
                  <div style={{ fontSize: 11, color: '#94A3B8', fontWeight: 400, marginTop: 2 }}>
                    {item.barcode}
                  </div>
                )}
              </td>
              <td>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  {item.imageUrl ? (
                    <img
                      src={item.imageUrl}
                      alt=""
                      style={{
                        width: 36, height: 36, objectFit: 'cover',
                        borderRadius: 6, border: '1px solid #E5E7EB',
                        flexShrink: 0,
                      }}
                    />
                  ) : (
                    <div
                      aria-hidden
                      style={{
                        width: 36, height: 36, borderRadius: 6,
                        background: '#F3F4F6', flexShrink: 0,
                      }}
                    />
                  )}
                  <div>
                    <div className={styles.productName}>{item.name}</div>
                    {item.ageRestriction && (
                      <span className={styles.ageBadge}>{item.ageRestriction}</span>
                    )}
                  </div>
                </div>
              </td>
              <td>
                <span
                  className={styles.categoryBadge}
                  style={{ color: categoryColors[item.category] || '#6B7280' }}
                >
                  {item.category}
                </span>
              </td>
              <td className={styles.right}>${item.cost.toFixed(2)}</td>
              <td className={`${styles.right} ${styles.tierA}`}>${item.tierA.toFixed(2)}</td>
              <td className={`${styles.right} ${styles.tierB}`}>${item.tierB.toFixed(2)}</td>
              <td className={`${styles.right} ${styles.tierC}`}>${item.tierC.toFixed(2)}</td>
              <td className={`${styles.right} ${styles.tierD}`}>${item.tierD.toFixed(2)}</td>
              <td className={styles.right}>{item.stock.toLocaleString()}</td>
              <td className={`${styles.right} ${styles.margin}`}>{item.margin.toFixed(1)}%</td>
              {showActions && (
                <td>
                  <RowActionsMenu
                    onEdit={onEdit ? () => onEdit(item.id) : undefined}
                    onDelete={onDelete ? () => onDelete(item.id) : undefined}
                  />
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
